var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pid)?_c('router-link',{staticClass:"project-name-link",attrs:{"to":{ path: '/project/detail', query: { id: String(_vm.pid) } },"title":_vm.label},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(_vm.label))]):_c('span',[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }